module.exports = __webpack_public_path__ + "static/media/5- achat responsable.0c31efbf.png";